// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vEm0","name":"styles_name__3C48x","phone":"styles_phone__2y0a8"};